import { LIST_GENDER } from "../LocalConst";

export class RegisterCard {
  quantity = 1;
  startDate = new Date();
  endDate = null;
  marketingVoucherCode = null;
  note = null;
  discount = null;
  percentDiscount = null;
  price = null;
  staffRevenues = [];
  cardUsers = [];
}
